import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom'
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import { useSelector, useDispatch } from 'react-redux';

import styles from '../../utils/navTabStyle';

const useStyles = makeStyles(theme => ({
  ...styles
}))

 const  routeLinks =   {
            "/": "Home",
           "/deepdive": "Deep Dive",
           "/helpfullinks": " Helpful Links",
           "/essentials" : "Essentials",
           "/faq": "FAQ",
          }

const SubHeader = (props) => {
    const locs = useLocation();
    const classes = useStyles();
  const { title, pandemic } = props;
  const [headerTitle, setHeaderTitle] = React.useState("Home")
 // const [ location, setLocation ] = React.useState(locs.pathname)
 
           
React.useEffect(() => {
    let str = "";
    if(locs.pathname.startsWith('/country/')){
      str = locs.pathname.substring(9)
    setHeaderTitle(str)
  
  }else if(locs.pathname.startsWith('/country')){
      setHeaderTitle("All Countries") 
      
  }else{
     str = locs.pathname;
    setHeaderTitle(routeLinks[str]);
    
  }
  }, []);

          
React.useEffect(() => {
    let str = "";
    if(locs.pathname.startsWith('/covid19/country/')){
      str = locs.pathname.substring(17)
    setHeaderTitle(str)
  
  }else if(locs.pathname.startsWith('/covid19/country')){
      setHeaderTitle("All Countries") 
      
  }else{
     str = locs.pathname;
    setHeaderTitle(routeLinks[str]);
    
  }
  }, [locs]);

  

   const dispatch = useDispatch();
 
  let headerText = useSelector(state => state.user.headerText);

  return (
    
      <AppBar
        component="div"
        className={classes.secondaryBar}
        color="primary"
        position="sticky"
        elevation={0}
      >
        <Toolbar>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs>
              <Typography color="inherit" variant="h5" component="h1">
               {headerTitle} 
              </Typography>
            </Grid>
            <Grid item>
              <Button className={classes.button} variant="outlined" color="inherit" size="small">
                covid-19
              </Button>
            </Grid>
            

          </Grid>
        </Toolbar>
      </AppBar>

  );
}

SubHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  
};

export default SubHeader;



